import script from "./PaperProductsStraightShops.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaperProductsStraightShops.vue?vue&type=script&lang=ts&setup=true"

import "./PaperProductsStraightShops.vue?vue&type=style&index=0&id=53239288&lang=scss"

const __exports__ = script;

export default __exports__